module.exports = __webpack_public_path__ + "img/smart-home.a977d5e0.svg";